module.exports = __webpack_public_path__ + "img/intro.cd19cd84.jpg";